import { styled } from '@mui/system';
import { Box } from '@mui/material';
import { theme } from '../../lib/index';

export const StyledContainer = styled(Box, {})({
  position: 'relative',
  alignSelf: 'flex-start',

  display: 'flex',
  margin: '25px 0 35px 0',
  width: 'fit-content',

  alignItems: 'center',

  '& .MuiIconButton-root': {
    marginRight: 20,
    padding: 0,

    background: 'transparent',

    transition: `${theme.transitions.create(['background'], {
      duration: theme.transitions.duration.standard,
    })}`,
  },
});
